import { render, staticRenderFns } from "./SalesManagerCreatedCpCard.vue?vue&type=template&id=661549d0&scoped=true"
import script from "./SalesManagerCreatedCpCard.vue?vue&type=script&lang=js"
export * from "./SalesManagerCreatedCpCard.vue?vue&type=script&lang=js"
import style0 from "./SalesManagerCreatedCpCard.vue?vue&type=style&index=0&id=661549d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661549d0",
  null
  
)

export default component.exports